import { useMemo } from 'react';

import { DownloadSingleResponse, FileRevisionID } from '@playq/octopus2-files';
import { GenericFailure, GenericFailureCode } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { logSnackbarError } from '/common/snackbarService';

export const fileGetDownloadUrlKeys: unknown[] = ['file', 'get', 'downloadUrl'];

export const useFileGetDownloadUrl = (
  id?: FileRevisionID,
  preview?: boolean,
  sourceName?: string,
  options?: IUseQueryOptionsExtended<DownloadSingleResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => fileGetDownloadUrlKeys.concat(id, preview), [id, preview]);

  const enabled = useMemo(() => options?.enabled !== false && id !== undefined, [options?.enabled, id]);

  const { ...res } = useEitherQuery(
    keys,
    () => services2.filesService.download(id as FileRevisionID, preview ?? false),
    {
      ...options,
      staleTime: Infinity,
      enabled,
      meta: {
        onError: (error: GenericFailure) => {
          if (error.code === GenericFailureCode.EntityNotFound) {
            const errorReason = error.message.split(`\\nReason:`)[1] ?? GenericFailureCode.EntityNotFound;
            console.error(`${sourceName ?? ''}: ${errorReason}. [${(id as FileRevisionID).serialize()}]`);
          } else {
            logSnackbarError(error, true);
          }
        },
      },
    }
  );

  return {
    url: res.data?.url,
    ...res,
  };
};
